import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import WebMercatorViewport from 'viewport-mercator-project';

var Viewport = function () {
  function Viewport() {
    _classCallCheck(this, Viewport);

    _defineProperty(this, "viewport", void 0);
  }

  _createClass(Viewport, [{
    key: "syncWithMapCamera",
    value: function syncWithMapCamera(mapCamera) {
      var center = mapCamera.center,
          zoom = mapCamera.zoom,
          pitch = mapCamera.pitch,
          bearing = mapCamera.bearing,
          viewportHeight = mapCamera.viewportHeight,
          viewportWidth = mapCamera.viewportWidth;
      this.viewport = new WebMercatorViewport({
        width: viewportWidth,
        height: viewportHeight,
        longitude: center && center[0],
        latitude: center && center[1],
        zoom: zoom,
        pitch: pitch,
        bearing: bearing
      });
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return this.viewport.zoom;
    }
  }, {
    key: "getZoomScale",
    value: function getZoomScale() {
      return Math.pow(2, this.getZoom());
    }
  }, {
    key: "getCenter",
    value: function getCenter() {
      return [this.viewport.longitude, this.viewport.latitude];
    }
  }, {
    key: "getProjectionMatrix",
    value: function getProjectionMatrix() {
      return this.viewport.projectionMatrix;
    }
  }, {
    key: "getModelMatrix",
    value: function getModelMatrix() {
      return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    }
  }, {
    key: "getViewMatrix",
    value: function getViewMatrix() {
      return this.viewport.viewMatrix;
    }
  }, {
    key: "getViewMatrixUncentered",
    value: function getViewMatrixUncentered() {
      return this.viewport.viewMatrixUncentered;
    }
  }, {
    key: "getViewProjectionMatrix",
    value: function getViewProjectionMatrix() {
      return this.viewport.viewProjectionMatrix;
    }
  }, {
    key: "getViewProjectionMatrixUncentered",
    value: function getViewProjectionMatrixUncentered() {
      return this.viewport.viewProjectionMatrix;
    }
  }, {
    key: "getFocalDistance",
    value: function getFocalDistance() {
      return 1;
    }
  }, {
    key: "projectFlat",
    value: function projectFlat(lngLat, scale) {
      return this.viewport.projectFlat(lngLat, scale);
    }
  }]);

  return Viewport;
}();

export { Viewport as default };
//# sourceMappingURL=Viewport.js.map